import * as React from 'react';
import UISection from 'UIComponents/section/UISection';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import ObjectNameLabel from 'flow-doctor-lib/components/common/ObjectNameLabel';
import { getIsInternal } from 'flow-doctor-lib/constants/Env';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITag from 'UIComponents/tag/UITag';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EnrollmentValidationResultsSummary = ({
  objectId,
  shouldEnroll,
  flowRevision,
  validationChecksByStatus
}) => {
  return /*#__PURE__*/_jsxs(UISection, {
    children: [/*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      marginBlockEnd: "400",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h4",
        "aria-level": 3,
        marginInlineEnd: "200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.summary.title"
        })
      }), /*#__PURE__*/_jsx(UITag, {
        use: shouldEnroll ? 'success' : 'danger',
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: shouldEnroll ? 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.summary.wouldEnroll' : 'flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.summary.wouldNotEnroll'
        })
      })]
    }), shouldEnroll ? /*#__PURE__*/_jsx("span", {
      "data-test-id": "non-enrollment-summary",
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.summary.success_jsx",
        elements: {
          ObjectNameLabel,
          b: 'b'
        },
        options: {
          objectNameLabel: {
            objectId,
            objectTypeId: flowRevision.flow.objectTypeId,
            portalId: flowRevision.portalId,
            showId: getIsInternal()
          }
        }
      })
    }) : /*#__PURE__*/_jsx("span", {
      "data-test-id": "non-enrollment-summary",
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        "data-test-id": "non-enrollment-summary",
        message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.summary.failure_jsx",
        elements: {
          ObjectNameLabel,
          b: 'b'
        },
        options: {
          count: validationChecksByStatus.failed.length,
          objectNameLabel: {
            objectId,
            objectTypeId: flowRevision.flow.objectTypeId,
            portalId: flowRevision.portalId,
            showId: getIsInternal()
          }
        }
      })
    })]
  });
};
export default EnrollmentValidationResultsSummary;